import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { Role } from "@/core/components/auth/auth.types";
import { ErrorComponent } from "@/core/components/ErrorComponent";
import { LoadingList } from "@/core/components/LoadingList";
import { getEvents } from "@/core/components/sites/site/events/eventsQueryOptions";

const eventsSearchSchema = z.object({
	page: z.number().catch(1),
	pageSize: z.number().catch(10),
	search: z.string().catch(""),
	sortBy: z
		.enum(["name", "eventCode", "startDateUTC", "endDateUTC"])
		.catch("startDateUTC"),
	orderBy: z.enum(["asc", "desc"]).catch("asc"),
});

export const Route = createFileRoute(
	"/_layout/dashboard/sites/$siteId/events/",
)({
	validateSearch: (search) => eventsSearchSchema.parse(search),
	beforeLoad: ({ context: { auth } }) => {
		if (auth.isExpired()) {
			return;
		}
		if (!auth.isAuthenticated) {
			throw redirect({
				to: "/",
			});
		}
		if (
			auth.user?.role === Role["Front-Desk"] ||
			auth.user?.role === Role["Blogger"]
		) {
			throw redirect({
				to: "/dashboard",
			});
		}
	},
	loader: ({ context: { queryClient, auth }, params: { siteId } }) => {
		const events = queryClient.ensureQueryData(getEvents(siteId, auth.token!));
		return {
			events,
		};
	},
	pendingComponent: LoadingList,
	errorComponent: ErrorComponent,
});
